module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_2-d1bd677c52da782058b964ea499411f1.jpg";